import { redirect } from "react-router-dom";
import { IApiResponse, IRedirect } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class RedirectService extends BaseService {
  
  public getRedirects = async (strict: boolean = false) : Promise<Array<IRedirect>> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/GetRedirects/${this.siteKey}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve page redirects");
          if (strict) throw new Error("Unable to load redirects");
        }
      }
    }
    return [];
  }

  public saveRedirect = async (redirect: IRedirect) : Promise<IRedirect | null> => {
    if (this.siteKey && redirect) {
      const remapped: IRedirect = {
        ...redirect,
        SourceUrl: redirect.RedirectUrl ?? "",
        RedirectId: redirect.Id,
        SiteId: this.siteKey
      };
      const url: string = `/SiteAdmin/AddUpdateRedirect`;
      const res = await this._ajaxService.Post<IApiResponse>(url, remapped, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save redirect details");
      }
    }
    return null;
  }

  public deleteRedirect = async (id: number) : Promise<boolean> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/DeleteRedirect/${this.siteKey}/${id}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200) {
        return true;
      }
    }
    return false;
  }

  public newRedirect = () : IRedirect | null => {
    if (this.siteKey) {
      return {
        Id: 0,
        PageId: 0,
        RedirectUrl: "",
        SourceUrl: "",

        Page: null
      };
    }
    return null;
  }
}